'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'wand-magic-sparkles';
var width = 640;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M16 128l80 32 32 80 32-80 80-32-80-32-32-80-32 80-80 32zM208 32l56 24 24 56 24-56 56-24-56-24-24-56-24 56-56 24zm153.4 89.4c31.1 31.1 62.2 62.2 93.3 93.3 44.9-44.9 89.8-89.8 134.6-134.6L496-13.3c-44.9 44.9-89.8 89.8-134.6 134.6zM384 400l80 32 32 80 32-80 80-32-80-32-32-80-32 80-80 32z', 'M454.6 214.6L361.4 121.4 50.7 432 144 525.3 454.6 214.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;